//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import CartSidebarPaynowPaymentMethod from '~/mixins/stripe/paynow/cart-sidebar'
import PageMixin from '~/mixins/page'
import PlansMixin from '~/mixins/plans'

export default {
  mixins: [
    PageMixin,
    CartSidebarPaynowPaymentMethod,
    PlansMixin
  ],
  data () {
    return {
      payNowButtonsId: ['#payment-request-button-header', '#payment-request-button-billing', '#payment-request-button-floating'],
      plan: 'base-complete-improvement-plan',
      showFloatingButton: false
    }
  },
  head () {
    return {
      ...this.createSeoTags({
        title: this.$t('completeTestingPlan.seo.title'),
        description: this.$t('completeTestingPlan.seo.description'),
        url: 'https://get-base.com/complete-testing-plan'
      })
    }
  },
  mounted () {
    window.addEventListener('scroll', () => {
      if (this.$refs.header && this.$refs.header.$el) {
        this.showFloatingButton = !this.isElementInViewport(this.$refs?.header?.$el)
      }
    }, { passive: true })
  },
  computed: {
    ...mapGetters({
      getPlanPriceRaw: 'product/getPlanPriceRaw'
    }),
    isPayUpfrontActiveAb () {
      return this.isABActivated('pay-upfront-project')
    },
    isPaynowStickyButtonActiveAb () {
      return this.isABActivated('sticky-paynow-button')
    }
  },
  created () {
    this.setPayNow()
  },
  methods: {
    openRemoveQuizPlanModal () {
      this.$store.dispatch('product/selectPlanToAdd', this.plan)
      this.$root.$emit('bv::show::modal', 'removeQuizPlanModal')
    },
    setPayNow () {
      this.$store.commit('product/setPayNowPlan', this.plan)
      this.$store.commit('product/setPayNowArea', 'diet')
    }
  }
}
